import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import { SETTINGS_RESOURCES, PAGE_NAMES, Entity } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import SettingsHome from './SettingsHome';
import { URL, COMPONENT } from './helper';

const Dashboard: React.FC<{}> = () => {
	// console.log(commons);
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.settings}
					path={`/${PAGE_NAMES.settings}`}
					component={SettingsHome}
				/>
				{_map(_values(SETTINGS_RESOURCES), (entity: Entity) => (
					<AuthorizedRoute
						key={entity}
						configPageName={PAGE_NAMES.settings}
						entity={entity}
						path={URL[entity]}
						component={COMPONENT[entity]}
					/>
				))}
				<Redirect to={`/${PAGE_NAMES.settings}`} />
			</Switch>
		</>
	);
};

export default Dashboard;
